import { Box, Button, Typography } from "@mui/material";
import { Home } from "lucide-react";
import type * as React from "react";
import { useLocation } from "react-router-dom";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { UnauthenticatedLayout } from "web_myplann/Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "web_myplann/Shared/Routing/UnstyledLink";

export const Error404Page: React.FunctionComponent = (_) => {
	const location = useLocation();

	const { t } = useResource();

	return (
		<UnauthenticatedLayout title={"404"}>
			<Box>
				<Typography variant="h1" mb={2}>
					Error 404
				</Typography>
				<Typography variant="h6" mb={2}>
					{location.pathname}
				</Typography>
				<Typography variant="h2" mb={2}>
					{t(Resources.Errors.Error404.Subtitle)}
				</Typography>
				<UnstyledLink to="/">
					<Button
						startIcon={<Home />}
						size="large"
						variant="contained"
						color="primary"
					>
						{t(Resources.Errors.Error404.Home)}
					</Button>
				</UnstyledLink>
			</Box>
		</UnauthenticatedLayout>
	);
};
